/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hook';

import { DarkButton } from './dark-button';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectSession } from '../redux/slices/sessionSlice';
import SignaturePad from 'react-signature-canvas';
import useState from 'react-usestateref';

//import { fetchPropertyInfo } from '../redux/slices/sessionSlice';

const CANVAS_HEIGHT = '200px';
//submit, setIsEmpty,

const Signature = React.forwardRef(
	({ submit, setIsEmpty, setSignature }, ref) => {
		Signature.displayName = 'Signature';
		const dispatch = useAppDispatch();
		const { token, reservation, propertyInfo } = useAppSelector(selectSession);
		//const [_, setSigPad, sigPadRef] = useState({});
		const sigPadRef = useRef({});

		const clear = () => {
			sigPadRef?.current?.clear();
			setIsEmpty(true);
		};
		// const captureSignatureForRegCard = () => {
		// 	const signatureData = sigPadRef?.current
		// 		?.getTrimmedCanvas()
		// 		?.toDataURL('image/png');
		// 	// Call the parent component's function with the signature data
		// 	setSignature(signatureData);
		// };
		// useEffect(() => {
		// 	/* eslint-disable no-debugger */
		// 	debugger;
		// 	console.log(
		// 		'useEffect--' +
		// 			token +
		// 			',' +
		// 			reservation +
		// 			',' +
		// 			submit +
		// 			',' +
		// 			reservation?.PmsConfirmationNo
		// 	);
		// 	/* eslint-enable no-debugger */
		// 	if (submit) {
		// 		// dispatch(
		// 		// 	submitSignature({
		// 		// 		token: token,
		// 		// 		reservationId: reservation?.ReservationID,
		// 		// 		confirmationNo: reservation?.PmsConfirmationNo,
		// 		// 		signature: sigPadRef?.current
		// 		// 			?.getTrimmedCanvas()
		// 		// 			?.toDataURL('image/png'),
		// 		// 		propertyCode: propertyInfo?.propertyCode ?? '', //added new
		// 		// 	})
		// 		// );
		// 		// dispatch(
		// 		// 	setSignature(
		// 		// 		sigPadRef?.current?.getTrimmedCanvas()?.toDataURL('image/png')
		// 		// 	)
		// 		// );
		// 	}
		// }, [submit, reservation?.PmsConfirmationNo]);
		React.useImperativeHandle(ref, () => ({
			captureSignature,
			// Other methods or properties you want to expose
		}));
		const captureSignature = () => {
			return sigPadRef?.current?.getTrimmedCanvas()?.toDataURL('image/png');
		};

		useEffect(() => {
			const onResize = () => {
				if (sigPadRef?.current) {
					//if (sigPadRef?.current?.isEmpty())
					setIsEmpty(true);
				}
			};

			// eslint-disable-next-line no-undef
			window.addEventListener('resize', onResize);
			//dispatch(setSignature(null));

			return () => {
				// eslint-disable-next-line no-undef
				window.removeEventListener('resize', onResize);
			};
		}, []);
		useEffect(() => {
			if (submit) {
				setSignature(
					sigPadRef?.current?.getTrimmedCanvas()?.toDataURL('image/png')
				);
				console.log(
					sigPadRef?.current?.getTrimmedCanvas()?.toDataURL('image/png')
				);
			}
		}, [submit]);
		useEffect(() => {
			if (sigPadRef?.current && sigPadRef.current !== null) {
				const canvas = sigPadRef.current.getCanvas();
				canvas.style.width = '100%';
				canvas.style.height = CANVAS_HEIGHT;
				canvas.style.borderRadius = '15px';
				canvas.width = canvas.offsetWidth;
				canvas.height = canvas.offsetHeight;

				// dispatch(
				// 	setSignature(
				// 		sigPadRef?.current?.getTrimmedCanvas()?.toDataURL('image/png')
				// 	)
				// );
				// setSignature(
				// 	sigPadRef?.current?.getTrimmedCanvas()?.toDataURL('image/png')
				// );
				// console.log(
				// 	sigPadRef?.current?.getTrimmedCanvas()?.toDataURL('image/png')
				// );
			} else {
				//dispatch(setSignature(null));
				//this.props.signatureImg('');
				//setSignature('');
			}
		}, [sigPadRef?.current]);

		return (
			<>
				<div
					className="bg-white w-100 mx-auto theme-signature"
					style={{
						border: 'solid 1px #00000042',
						borderRadius: '15px',
						maxWidth: '1000px',
						position: 'relative',
						maxHeight: CANVAS_HEIGHT,
						height: CANVAS_HEIGHT,
						minHeight: CANVAS_HEIGHT,
					}}>
					<FontAwesomeIcon
						icon={faRotateRight}
						className={'m-2'}
						style={{
							cursor: 'pointer',
							height: '20px',
							width: '20px',
							position: 'absolute',
							right: '0',
							top: '0',
							color: '#03355C',
						}}
						onClick={clear}
					/>
					<SignaturePad
						ref={(ref) => {
							sigPadRef.current = ref;

							// setSignature(
							// 	sigPadRef?.current?.getTrimmedCanvas()?.toDataURL('image/png')
							// );
							// console.log(
							// 	sigPadRef?.current?.getTrimmedCanvas()?.toDataURL('image/png')
							// );
							// setIsEmpty(false);
							// if (sigPadRef.current !== null && sigPadRef.current !== undefined)
							// 	dispatch(
							// 		setSignature(
							// 			sigPadRef?.current?.getTrimmedCanvas()?.toDataURL('image/png')
							// 		)
							// 	);
						}}
						onBegin={() => {
							setIsEmpty(false);
						}}
					/>
				</div>
			</>
		);
	}
);

export default Signature;
